const map = {
	"./ar/feed.json": [
		77542,
		[
			7542
		]
	],
	"./de/feed.json": [
		81186,
		[
			1186
		]
	],
	"./en/feed.json": [
		47446,
		[
			7446
		]
	],
	"./es/feed.json": [
		6155,
		[
			6155
		]
	],
	"./fa/feed.json": [
		39188,
		[]
	],
	"./fr/feed.json": [
		42563,
		[
			2563
		]
	],
	"./ja/feed.json": [
		97704,
		[
			7704
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	const e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	const ids = map[req], id = ids[0];
	return Promise.all(ids[1].map(__webpack_require__.e)).then(() => (__webpack_require__.t(id, 3 | 16)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 77876;
module.exports = webpackAsyncContext;